// extracted by mini-css-extract-plugin
export default {"xs":"0","sm":"576","md":"768","lg":"892","xl":"1200","dashboard":"Dashboard_dashboard__q8jAW","container":"Dashboard_container__mXq9W"};